import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { ProgressSpinnerComponent } from './widgets/progress-spinner/progress-spinner.component';
import { LoadingService } from './services/loading.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PopupType } from './widgets/app-popup/app-popup.component';
import {
  MSAL_GUARD_CONFIG,
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalModule,
  MsalService,
} from '@azure/msal-angular';
import {
  InteractionStatus,
  RedirectRequest,
  EventMessage,
  EventType,
  AuthError,
} from '@azure/msal-browser';
import { filter, Subject, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import { AccessDeniedPopupComponent } from './widgets/access-denied-popup/access-denied-popup.component';
import { CookieConsentComponent } from './widgets/cookie-consent/cookie-consent.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    MsalModule,
    RouterOutlet,
    ProgressSpinnerComponent,
    CookieConsentComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'UI';
  isIframe = false;
  loginDisplay = false;
  loggedinUserName: any;
  private readonly _destroying$ = new Subject<void>();
  isCustomReportRouteEnabled: boolean = false;

  constructor(
    private readonly loadingService: LoadingService,
    private readonly router: Router,
    private readonly dialog: MatDialog,
    @Inject(MSAL_GUARD_CONFIG)
    private readonly msalGuardConfig: MsalGuardConfiguration,
    private readonly authService: MsalService,
    private readonly msalBroadcastService: MsalBroadcastService
  ) {
    // session id logic for Sparci(to open in new tab)
    // prettier-ignore
    const sessionValue = new URLSearchParams(window.location.search); //NOSONAR
    const sessionId = sessionValue.get('sessionid');
    // prettier-ignore
    if (sessionId != null) { //NOSONAR
      sessionStorage.setItem('sessionId', sessionId);
    } else {
      sessionStorage.getItem('sessionId');
    }

    //to get project details
    // prettier-ignore
    const projParams = new URLSearchParams(window.location.search); //NOSONAR
    const projId = projParams.get('projectID');
    const clickedcustomreports = projParams.get('clickedcustomreports');
    const clickedSparci2 = projParams.get('clickedSparci2');

    // prettier-ignore
    if (projId != null) { //NOSONAR
      localStorage.setItem('projectId', projId);
    } else {
      // prettier-ignore
      if(clickedcustomreports === 'true'){ //NOSONAR
        localStorage.setItem('isSparci', 'false');
        localStorage.setItem('projectId', 'not_available');
      }else if(clickedSparci2 === 'true'){
        localStorage.setItem('isSparci', 'true');
        localStorage.getItem('projectId');
      }
      
    }

    //to get user id
    // prettier-ignore
    const userIdValue = new URLSearchParams(window.location.search); //NOSONAR
    console.log('userIdValue', userIdValue);
    const userId = projParams.get('userId');
    // prettier-ignore
    if (userId != null) { //NOSONAR
      localStorage.setItem('userId', userId);
    } else {
      localStorage.getItem('userId');
    }

    this.targetPage();
    this.envUrlDetails();
    //NOSONAR
    // localStorage.setItem('environment', 'dev');
    // localStorage.setItem('urlDomain', 'sb-unilever-claims.veevavault.com');
    // localStorage.setItem('vaultDomain', 'https://sb-unilever-claims.veevavault.com');
    // localStorage.setItem('environment', 'qa');
    // localStorage.setItem('urlDomain', 'sb-unilever-claims-qa.veevavault.com');
    // localStorage.setItem(
    //   'vaultDomain',
    //   'https://sb-unilever-claims-qa.veevavault.com'
    // );
  }

  ngOnInit() {
    this.loadingService.setLoading(true);
    //NOSONAR
    // this.getSessionId();
    // this.getProjectId();
    this.authService.handleRedirectObservable().subscribe();
    // prettier-ignore
    this.isIframe = window !== window.parent && !window.opener; // NOSONAR // Remove this line to use Angular Universal

    this.setLoginDisplay();

    this.authService.instance.enableAccountStorageEvents(); // Optional - This will enable ACCOUNT_ADDED and ACCOUNT_REMOVED events emitted when a user logs in or out of another tab or window
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.ACCOUNT_ADDED ||
            msg.eventType === EventType.ACCOUNT_REMOVED
        )
      )
      .subscribe((result: EventMessage) => {
        if (this.authService.instance.getAllAccounts().length === 0) {
          // prettier-ignore
          window.location.pathname = '/'; //NOSONAR
        } else {
          this.setLoginDisplay();
        }
      });

    //to handle login errors
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.ACQUIRE_TOKEN_FAILURE
        )
      )
      .subscribe((msg: EventMessage) => {
        const errorMessage = (msg.error as AuthError).errorMessage;
        if (errorMessage) {
          // Handle ERROR ServerError: access_denied: AADB2C90091: The user has cancelled entering self-asserted information
          // prettier-ignore
          if (errorMessage.indexOf('AADB2C90091') > -1) { //NOSONAR
            this.authService.instance.loginRedirect();
          }
        }
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
      });

    if (
      sessionStorage.getItem('sessionId') == null ||
      localStorage.getItem('environment') == undefined
    ) {
      if (
        (!localStorage.getItem('projectId') ||
          localStorage.getItem('projectId') === 'not_available') &&
        localStorage.getItem('isSparci') === 'true'
      ) {
        this.showAccessDeneiedError();
      }
    }
    // }

    this.loadingService.setLoading(false);
  }

  getSessionId() {
    const sessionId =
      'A88095675EBE18276193B25CFDE179009BF27F96680435A8C3979DCDB64CF8464C69AA8F006A13DF8CFFFF97F3E277807B6CEF84DCE21BC1F547C6BA613574E2';
    sessionStorage.setItem('sessionId', sessionId);
  }

  getProjectId() {
    //prettier-ignore
    let projectId = 'V2C00000000F002'; //NOSONAR
    //NOSONAR
    //let projectId = 'V2C00000000F002';
    //let projectId = 'V2C00000005A003'; // QA
    // let projectId = 'V2C00000004Z002';
    //let projectId = 'V2C00000004N001';
    //let projectId = 'V2C00000007N004'; // QA SPARCi Project
    //let projectId = 'V2C00000007M004'; // Saprci_2.0_test
    //let projectId = 'V2C000000021001'; //custom report
    //let projectId = 'V2C000000080004'; // QA SPARCi 2.0 Test ProjectS
    localStorage.setItem('projectId', projectId);
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    console.log('login display', this.loginDisplay);
  }

  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.authService.instance.getActiveAccount();
    console.log('active acc', activeAccount);
    if (
      !activeAccount &&
      this.authService.instance.getAllAccounts().length > 0
    ) {
      let accounts = this.authService.instance.getAllAccounts();
      console.log('acc info', accounts);
      console.log('active acc', activeAccount);
      this.loggedinUserName = accounts[0]?.name;
      sessionStorage.setItem(
        'loggedInUser',
        this.loggedinUserName?.split(',')[1]
      );
      sessionStorage.setItem('username', accounts[0].username);
      this.authService.instance.setActiveAccount(accounts[0]);
    } else {
      console.log('active acc', activeAccount);
      this.loggedinUserName = activeAccount?.name;
      sessionStorage.setItem(
        'loggedInUser',
        this.loggedinUserName?.split(',')[1]
      );
      sessionStorage.setItem('username', activeAccount?.username);
    }
  }

  loginRedirect() {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginRedirect({
        ...this.msalGuardConfig.authRequest,
      } as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }

  logout(popup?: any) {
    if (popup) {
      this.authService.logoutPopup({
        mainWindowRedirectUri: '/',
      });
    } else {
      this.authService.logoutRedirect();
    }
  }

  /**to set target page */
  targetPage() {
    // prettier-ignore
    const targetPage = new URLSearchParams(window.location.search); //NOSONAR
    const pageDetails: any = targetPage.get('targetPage');
    const clickedSparci2 = targetPage.get('clickedSparci2');
    const clickedcustomreports = targetPage.get('clickedcustomreports');
    // prettier-ignore
    console.log('route url', window.location.href.split('#')[1]); //NOSONAR

    const allKeys = Object.keys(localStorage);
    const beginHereKeys = allKeys.filter((key) =>
      key.startsWith('begin_here_')
    );
    beginHereKeys.forEach((key) => localStorage.removeItem(key));

    // prettier-ignore
    if (
      pageDetails == 'edit_claims' ||
      window.location.href.split('#')[1] == '/edit-claims-la' || //NOSONAR
      window.location.href.split('#')[1] == '/edit-la-confirm' || //NOSONAR
      window.location.href.split('#')[1] == '/edit-claims-confirm' //NOSONAR
    ) {
      // add route of confirmation pages of LA-claim
      this.router.navigate(['/bulkentry/edit-claims-la']);
    } else if (clickedSparci2 === 'true') {
      this.router.navigate(['/bulkentry/home']);
    } else if (clickedcustomreports === 'true') {
      this.router.navigate(['/customreports']);
    }
  }

  /**to get url details*/
  envUrlDetails() {
    // prettier-ignore
    const envParams = new URLSearchParams(window.location.search); //NOSONAR
    const env: any = envParams.get('env');
    // prettier-ignore
    if (localStorage.getItem('urlDomain') != null) { //NOSONAR
      localStorage.getItem('urlDomain');
    } else {
      localStorage.setItem('urlDomain', env);
    }

    let environment;
    if (
      localStorage.getItem('urlDomain') == 'sb-unilever-claims.veevavault.com'
    ) {
      localStorage.setItem('environment', 'dev');
    } else if (
      localStorage.getItem('urlDomain') ==
      'sb-unilever-claims-sandbox--limited-release.veevavault.com'
    ) {
      localStorage.setItem('environment', 'sandbox');
    } else if (
      localStorage.getItem('urlDomain') ==
      'sb-unilever-claims-qa.veevavault.com'
    ) {
      localStorage.setItem('environment', 'qa');
    } else if (
      localStorage.getItem('urlDomain') ==
      'sb-unilever-claims-training.veevavault.com'
    ) {
      localStorage.setItem('environment', 'trn');
    } else if (
      localStorage.getItem('urlDomain') == 'unilever-bbfclaims.veevavault.com'
    ) {
      localStorage.setItem('environment', 'prod');
    }

    // prettier-ignore
    if (window?.location?.href?.includes('customreports')) { //NOSONAR
      this.isCustomReportRouteEnabled = true;
    } else {
      this.isCustomReportRouteEnabled = false;
    }
  }

  // to show access denied popup when user trying Sparci URL directly
  showAccessDeneiedError() {
    console.log(
      'You will be able to access SPARCi only via a Project in Veeva Claims.'
    );
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.height = '260px';
    dialogConfig.width = '345px';
    dialogConfig.data = {
      icon: '../../../assets/images/icons/access-denied.png',
      method: 'redirect',
      message:
        'You will be able to access SPARCi only via a Project in Veeva Claims.',
      type: PopupType.ERROR,
    } as any;
    this.dialog
      .open(AccessDeniedPopupComponent, dialogConfig)
      .afterClosed()
      .subscribe((response) => {});
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
